import { render, staticRenderFns } from "./KeyFeatures.vue?vue&type=template&id=5d080d3c&scoped=true"
import script from "./KeyFeatures.vue?vue&type=script&lang=js"
export * from "./KeyFeatures.vue?vue&type=script&lang=js"
import style0 from "./KeyFeatures.vue?vue&type=style&index=0&id=5d080d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d080d3c",
  null
  
)

export default component.exports